var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotInterface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 594.2403,
    height: 379.9185,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 594.2403 379.9185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#197de5;}.cls-2{fill:#0031b3;}.cls-3{fill:url(#linear-gradient-3);}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{mix-blend-mode:color-dodge;}.cls-18{fill:url(#radial-gradient-10);}.cls-18,.cls-19,.cls-20,.cls-5,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25{opacity:.5;}.cls-18,.cls-26,.cls-22,.cls-23,.cls-24,.cls-27,.cls-28,.cls-29,.cls-30,.cls-25{mix-blend-mode:screen;}.cls-31,.cls-32{fill:#fff;}.cls-4{fill:url(#radial-gradient-7);}.cls-33{fill:#646da4;}.cls-34{fill:#6fcef6;}.cls-19,.cls-35,.cls-21,.cls-36,.cls-37{fill:#58fffe;}.cls-19,.cls-37,.cls-32{mix-blend-mode:soft-light;}.cls-38{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-3);}.cls-5{fill:url(#radial-gradient-8);}.cls-6{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13);}.cls-39{fill:#6dffe5;}.cls-7{fill:url(#linear-gradient-5);}.cls-40{fill:#6fe0f6;}.cls-41{isolation:isolate;}.cls-42,.cls-36,.cls-43{opacity:.2;}.cls-44{fill:#1b4bbf;}.cls-45{fill:#aeb8d2;}.cls-46{fill:#001b8d;}.cls-8{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_14-2);}.cls-9{fill:url(#radial-gradient-3);}.cls-47{fill:#196bdb;}.cls-26{fill:url(#radial-gradient-5);}.cls-26,.cls-28{opacity:.6;}.cls-48{fill:#7cffbf;}.cls-10{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_14);}.cls-49{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-2);}.cls-22{fill:url(#radial-gradient-13);}.cls-11{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_14-3);}.cls-23{fill:url(#radial-gradient-11);}.cls-24{fill:url(#radial-gradient-14);}.cls-50{fill:#4dd1ff;}.cls-51{fill:#17a8ed;}.cls-52{fill:#a49bc7;}.cls-53{fill:#c09ee9;}.cls-54{fill:#318fe8;}.cls-27{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_94);}.cls-12{fill:url(#linear-gradient-2);}.cls-55{fill:#85deda;}.cls-28{fill:url(#radial-gradient-4);}.cls-56{fill:#878bc4;}.cls-29{fill:url(#radial-gradient-15);}.cls-57{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37);}.cls-13{fill:url(#radial-gradient-9);}.cls-58{fill:#1b4fdb;}.cls-59{fill:#5b5b82;}.cls-60{fill:#00379f;}.cls-14{fill:url(#linear-gradient-4);}.cls-61{fill:#0b1e7d;}.cls-32{fill-rule:evenodd;}.cls-62{fill:#dee5f1;}.cls-63{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-4);}.cls-64{fill:#7cfff6;}.cls-65{fill:#b84b81;}.cls-43{fill:#196fc7;mix-blend-mode:multiply;}.cls-15{fill:url(#radial-gradient-6);opacity:.3;}.cls-16{fill:url(#linear-gradient);}.cls-30{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_41);}.cls-66{fill:#a954b8;}.cls-25{fill:url(#radial-gradient-12);}.cls-17{fill:url(#radial-gradient-2);}.cls-67{fill:url(#radial-gradient);opacity:.25;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -271.0058,
    cy: 264.5844,
    fx: -271.0058,
    fy: 264.5844,
    r: 70.8643,
    gradientTransform: "translate(816.2119 -333.0479) scale(2.1145 1.9959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0129,
    stopColor: "#3fbdff",
    stopOpacity: 0.9851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3854,
    stopColor: "#249aff",
    stopOpacity: 0.569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6844,
    stopColor: "#1080ff",
    stopOpacity: 0.2629
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "#0470ff",
    stopOpacity: 0.0731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -2406.095,
    cy: 123.4798,
    fx: -2406.095,
    fy: 123.4798,
    r: 42.0873,
    gradientTransform: "translate(-2138.0193) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a9cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02b3c4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -2502.4648,
    cy: 88.1228,
    fx: -2502.4648,
    fy: 88.1228,
    r: 60.3929,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -3327.0847,
    cy: -49.0663,
    fx: -3327.0847,
    fy: -49.0663,
    r: 17.9544,
    gradientTransform: "translate(-1513.2937 53.2321) rotate(-171.9287) scale(.6068 -.5642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27a6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0267,
    stopColor: "#27a6fc",
    stopOpacity: 0.9549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    stopColor: "#27a6fc",
    stopOpacity: 0.7056
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3415,
    stopColor: "#27a6fc",
    stopOpacity: 0.4904
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4926,
    stopColor: "#27a6fc",
    stopOpacity: 0.3145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#27a6fc",
    stopOpacity: 0.1776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7731,
    stopColor: "#27a6fc",
    stopOpacity: 0.0797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    stopColor: "#27a6fc",
    stopOpacity: 0.0205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27a6fc",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -3329.8285,
    cy: -15.2351,
    fx: -3329.8285,
    fy: -15.2351,
    r: 17.9543,
    gradientTransform: "translate(-1513.2937 53.2321) rotate(-171.9287) scale(.6068 -.5642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334,
    stopColor: "#ff2c77",
    stopOpacity: 0.9438
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1905,
    stopColor: "#ff2c77",
    stopOpacity: 0.6974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#ff2c77",
    stopOpacity: 0.4847
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#ff2c77",
    stopOpacity: 0.3108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6395,
    stopColor: "#ff2c77",
    stopOpacity: 0.1756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#ff2c77",
    stopOpacity: 0.0788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8984,
    stopColor: "#ff2c77",
    stopOpacity: 0.0203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2c77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_14",
    cx: -2038.4446,
    cy: 166.7856,
    fx: -2038.4446,
    fy: 166.7856,
    r: 20.161,
    gradientTransform: "translate(-1173.8775 -1609.066) rotate(-133.0634) scale(1.1393 -1.1393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -2036.479,
    cy: -400.475,
    fx: -2036.479,
    fy: -400.475,
    r: 14.5898,
    gradientTransform: "translate(-1943.6998 -167.856) rotate(-161.9388) scale(1.1392 -.5642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81d9fc",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -2162.2882,
    cy: -179.2226,
    fx: -2162.2882,
    fy: -179.2226,
    r: 14.5899,
    gradientTransform: "translate(252.1829 -2425.188) rotate(-89.9996) scale(1.1393 -1.0068)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02689b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -2215.2287,
    cy: -298.1908,
    fx: -2215.2287,
    fy: -298.1908,
    r: 27.2595,
    gradientTransform: "translate(199.3785 -1966.3962) rotate(-90.0014) scale(1.0374 -.6131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f94081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f94081",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_14-2",
    cx: -2935.4153,
    cy: -142.1644,
    fx: -2935.4153,
    fy: -142.1644,
    r: 21.3158,
    gradientTransform: "translate(-1484.0017 57.3978) rotate(-171.9289) scale(.646 -.5642)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_14-3",
    cx: -4758.3301,
    cy: -188.0597,
    fx: -4758.3301,
    fy: -188.0597,
    r: 21.3178,
    gradientTransform: "translate(-1111.8933 110.1412) rotate(-171.9274) scale(.324 -.5642)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13",
    cx: 318.1589,
    cy: 236.5616,
    fx: 318.1589,
    fy: 236.5616,
    r: 93.4153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02b3c4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -1794.545,
    cy: 29.76,
    fx: -1794.545,
    fy: 29.76,
    r: 41.8788,
    gradientTransform: "translate(-2425.6331 95.1342) rotate(-180) scale(1.5831 -1.5844)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f94081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 146.5093,
    y1: 307.6834,
    x2: 146.5093,
    y2: 289.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85deda",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85deda"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -1331.7489,
    cy: -260.0386,
    fx: -1331.7489,
    fy: -260.0386,
    r: 28.5389,
    gradientTransform: "translate(356.7565 -1221.8516) rotate(-90.0019) scale(1.1392 .8151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#03c4ff",
    stopOpacity: 0.8244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1651,
    stopColor: "#03c4ff",
    stopOpacity: 0.6331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#03c4ff",
    stopOpacity: 0.4632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3621,
    stopColor: "#03c4ff",
    stopOpacity: 0.3202
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4665,
    stopColor: "#03c4ff",
    stopOpacity: 0.2036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5764,
    stopColor: "#03c4ff",
    stopOpacity: 0.1135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6944,
    stopColor: "#03c4ff",
    stopOpacity: 0.0496
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#03c4ff",
    stopOpacity: 0.0119
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03c4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37",
    x1: 154.1928,
    y1: 298.8496,
    x2: 155.1576,
    y2: 243.5739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aabcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f1f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-2",
    x1: 157.6938,
    y1: 174.4076,
    x2: 158.8956,
    y2: 105.5558,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 156.2571,
    y1: 251.4334,
    x2: 156.2571,
    y2: 233.736,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-3",
    x1: 160.2994,
    y1: 240.3087,
    x2: 161.4086,
    y2: 176.7635,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 160.6484,
    y1: 180.7943,
    x2: 160.6484,
    y2: 165.3181,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-4",
    x1: 98.2771,
    y1: 275.0656,
    x2: 99.289,
    y2: 217.0885,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 115.4419,
    y1: 211.0902,
    x2: 135.9206,
    y2: 196.2115,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 121.8027,
    y1: 206.4688,
    x2: 135.9206,
    y2: 196.2115,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -1338.7075,
    cy: -202.0663,
    fx: -1338.7075,
    fy: -202.0663,
    r: 22.6769,
    gradientTransform: "translate(321.273 -1276.2243) rotate(-90.0021) scale(1.1392 .8151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -1339.0971,
    cy: -106.337,
    fx: -1339.0971,
    fy: -106.337,
    r: 24.9112,
    gradientTransform: "translate(250.0906 -1354.3989) rotate(-90.002) scale(1.1392 .8151)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 361.3984,
    cy: 857.4035,
    fx: 361.3984,
    fy: 857.4035,
    r: 30.738,
    gradientTransform: "translate(-318.1947 -459.0125) scale(1.1392 .8152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#494e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0378,
    stopColor: "#494e89",
    stopOpacity: 0.9381
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#494e89",
    stopOpacity: 0.6045
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4767,
    stopColor: "#494e89",
    stopOpacity: 0.342
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#494e89",
    stopOpacity: 0.1538
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#494e89",
    stopOpacity: 0.0398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494e89",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -1641.7799,
    cy: -45.0751,
    fx: -1641.7799,
    fy: -45.0751,
    r: 32.6206,
    gradientTransform: "translate(165.8538 -1315.3706) rotate(-89.998) scale(.8728 .8151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71e4ff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_94",
    cx: -348.6933,
    cy: 733.9274,
    fx: -348.6933,
    fy: 733.9274,
    r: 9.7152,
    gradientTransform: "translate(-896.3594 -82.1865) rotate(-93.4566) scale(.7878 1.4142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1563,
    stopColor: "#014fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    stopColor: "#013787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#002357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6396,
    stopColor: "#001431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7804,
    stopColor: "#000916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#000205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 412.7641,
    cy: 685.4249,
    fx: 412.7641,
    fy: 685.4249,
    r: 8.7681,
    gradientTransform: "translate(-828.7462 23.8095) rotate(-65.5428) scale(.7879 1.4142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1563,
    stopColor: "#0268ff",
    stopOpacity: 0.7606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    stopColor: "#0268ff",
    stopOpacity: 0.5321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#0268ff",
    stopOpacity: 0.3416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6396,
    stopColor: "#0268ff",
    stopOpacity: 0.1934
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7804,
    stopColor: "#0268ff",
    stopOpacity: 0.0871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#0268ff",
    stopOpacity: 0.0226
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41",
    cx: -1840.2565,
    cy: 71.2054,
    fx: -1840.2565,
    fy: 71.2054,
    r: 36.6573,
    gradientTransform: "translate(-1360.983 -28.5807) rotate(-177.3576) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#00090a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2911,
    stopColor: "#002428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5344,
    stopColor: "#005057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8229,
    stopColor: "#018b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02b3c4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "project_menagement"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 243.1702,
    cy: 195.036,
    rx: 149.8446,
    ry: 141.4363
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M484.3885,29.5226h0c10.4844-2.6697,21.8659,7.1636,21.8592,16.5229l-12.4525,295.6997c-.377,8.1012-12.3468,16.6758-19.8975,16.6758l-3.1976-1.5076,2.6377,.9477,11.0507-328.3385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M481.9027,350.6884l13.0828-313.8973c.2574-6.1774-6.2463-10.3348-11.7448-7.5077l-204.1415,104.9595c-2.5025,1.2867-4.1534,3.7848-4.356,6.5914l-11.1108,153.9448c-.2776,3.8458,2.206,7.35,5.9267,8.3621l202.1696,54.993c4.995,1.3587,9.9584-2.2737,10.174-7.4458Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "466.3866 346.351 267.8885 293.3529 279.1385 139.1029 483.0195 37.2219 466.3866 346.351"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "466.3866 346.351 271.7365 294.9663 282.9865 140.7163 482.824 40.8559 466.3866 346.351"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "346.9023 306.5795 272.148 289.3242 284.0526 147.8501 357.9881 116.5741 346.9023 306.5795"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "475.3885 55.3529 363.0935 112.2629 353.2922 307.8564 459.3885 335.8529 475.3885 55.3529"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "335.4014 300.7497 269.0514 286.5592 274.2536 205.0252 341.5639 198.6424 335.4014 300.7497"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "482.824 40.8559 481.7635 60.5666 282.2506 150.8064 282.9865 140.7163 482.824 40.8559"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "349.5166 114.3033 282.2268 146.4854 278.3911 200.8529 344.7762 196.1269 349.5166 114.3033"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "472.6385 48.6029 472.6385 61.8529 391.6385 99.1029 391.6385 88.8529 472.6385 48.6029"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "334.7513 94.5591 267.4616 126.7412 263.2807 175.9528 330.6889 164.679 334.7513 94.5591"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "334.7513 94.5591 335.5865 95.2519 331.7666 164.745 330.6889 164.679 334.7513 94.5591"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "303.9368 75.9755 236.2026 114.4577 232.2145 170.9842 291.2982 159.3539 299.1737 158.1902 303.9368 75.9755"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "301.2148 79.0278 300.6314 90.8611 237.0337 121.7356 237.6942 114.4575 301.2148 79.0278"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "303.9368 75.9755 304.8511 76.5892 300.0596 157.9486 299.1737 158.1902 303.9368 75.9755"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "415.9042 19.9568 318.7094 75.1764 312.9868 156.2888 397.7684 139.5999 409.0694 137.9302 415.9042 19.9568"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "411.9982 24.3365 411.1611 41.3167 319.9021 85.6199 320.8498 75.1763 411.9982 24.3365"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "415.9042 19.9568 417.2162 20.8373 410.3406 137.5835 409.0694 137.9302 415.9042 19.9568"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "309.8102 273.9826 237.7711 264.5867 241.5427 200.8529 314.7709 191.7864 309.8102 273.9826"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "314.7709 191.7864 315.8885 193.3999 310.6946 273.9826 309.8102 273.9826 314.7709 191.7864"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "287.1929 199.9699 285.6974 227.3237 261.7276 228.1963 263.2262 202.4944 287.1929 199.9699"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M478.7183,307.7619c-.7854,5.5393,3.4072,10.7145,9.3645,11.5591,5.9572,.8447,11.4232-2.961,12.2086-8.5003,.7854-5.5393-3.4072-10.7145-9.3645-11.5592-5.9572-.8446-11.4232,2.9611-12.2086,8.5004Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M477.6873,326.8937c-.7854,5.5392,3.4072,10.7145,9.3645,11.5592,5.9573,.8446,11.4232-2.9611,12.2086-8.5005,.7854-5.5392-3.4072-10.7145-9.3645-11.559-5.9571-.8447-11.4232,2.9611-12.2086,8.5003Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 272.9829,
    cy: 217.3441,
    r: 22.9685,
    transform: "translate(-73.7307 256.6867) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M408.3786,230.5892c-7.7197,0-14-9.8603-14-21.9795s6.2803-21.9799,14-21.9799,13.999,9.8603,13.999,21.9799-6.2803,21.9795-13.999,21.9795Zm0-43.0161c-7.1992,0-13.0566,9.437-13.0566,21.0366s5.8574,21.0362,13.0566,21.0362,13.0557-9.4366,13.0557-21.0362-5.8565-21.0366-13.0557-21.0366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M408.3786,265.9369c-19.9902,0-36.2539-25.7168-36.2539-57.3272s16.2637-57.3271,36.2539-57.3271,36.2529,25.7168,36.2529,57.3271-16.2627,57.3272-36.2529,57.3272Zm0-113.5986c-19.4082,0-35.1973,25.2431-35.1973,56.2714s15.7891,56.2705,35.1973,56.2705,35.1963-25.2431,35.1963-56.2705-15.7891-56.2714-35.1963-56.2714Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.6103,168.3977l-3.7487,13.7272c5.9276,4.6097,9.9359,14.6645,9.9076,26.3502l8.897-1.4085c-.1871-17.2124-6.2315-31.9466-15.0559-38.6689Zm-38.3552,40.1283c-.0527,1.8599-.0351,3.69,.046,5.5008l8.9081-.9111c-.0858-1.4196-.1079-2.8692-.0663-4.338,.2831-9.9968,3.4626-18.7589,8.1133-24.042l-4.5608-12.5877c-7.1202,7.8996-12.0103,21.1926-12.4403,36.378Zm38.2605,22.8804c-3.3228,4.9189-7.6998,7.8831-12.4114,7.7497-6.6139-.1873-12.2123-6.4058-15.0256-15.475l-8.1744,6.3891c4.1352,14.035,12.668,23.7103,22.7778,23.9966,7.2186,.2044,13.9057-4.4183,18.9335-12.1127l-6.0999-10.5477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M422.6578,166.9294l-4.6219,16.9249c-2.6385-2.0698-5.582-3.2485-8.7118-3.3371-4.7763-.1352-9.2676,2.2933-12.9947,6.556l-5.6231-15.5198c5.521-6.1287,12.1254-9.6187,19.1384-9.4202,4.5976,.1302,8.9253,1.8305,12.8131,4.7962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M394.7649,224.7135l-12.1918,9.5291c-2.1532-7.3011-3.5039-15.3838-3.8824-23.9281l13.2861-1.3589c.3288,5.6563,1.2972,10.9678,2.7881,15.7579Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M436.2871,206.9452c-.4341,15.3304-4.6071,29.0772-10.9634,38.7787l-7.4114-12.8155c4.3893-6.5063,7.2809-15.8433,7.5761-26.269,.0152-.5393,.0225-1.0659,.0221-1.5927l10.8099-1.7113c.0121,1.1953,.0009,2.4029-.0333,3.6098Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M355.3607,347.5638v-14.8252l-39.9722-12.8701v11.3203l39.9722,16.375Zm-1-14.0966v12.6064l-37.9722-15.5566v-9.2754l37.9722,12.2256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M316.2517,331.4601c-1.4096,4.3222,4.5225,10.1333,13.2497,12.9794,8.7271,2.8462,16.9446,1.6497,18.3542-2.6724,1.4095-4.3222-4.5225-10.1333-13.2497-12.9794-8.7272-2.8462-16.9446-1.6497-18.3542,2.6724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M322.1849,331.5892c.0977,0,.1968-.0283,.2832-.0888,.2276-.1563,.2847-.4678,.1279-.6954l-3.1181-4.5205,3.373-1.5849c.25-.1172,.3574-.4151,.2403-.6651-.1172-.249-.4156-.3564-.6651-.2392l-4.4414,2.0849,3.7881,5.4932c.0972,.1406,.2534,.2158,.4121,.2158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M326.7679,333.7689c.0923,0,.1856-.0254,.2691-.0791,.2324-.1484,.3003-.458,.1513-.6904l-2.9834-4.6592,3.2232-1.457c.2514-.1143,.3633-.4102,.2495-.6621-.1133-.251-.4107-.3604-.6616-.25l-4.2769,1.9336,3.6074,5.6337c.0952,.1495,.2569,.2305,.4214,.2305Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M424.0389,54.3954l17.9234-9.5225,.3081-20.8081-17.6856,11.6416-.5459,18.689Zm16.9321-10.1279l-15.8823,8.4375,.4805-16.4498,15.6733-10.3164-.2715,18.3287Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 432.602,
    cy: 38.1975,
    rx: 14.6892,
    ry: 16.621,
    transform: "translate(379.81 469.262) rotate(-88.0638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M426.7337,50.0956l12.3594-6.9854,.3941-13.7729-12.7535,8.1797v12.5786Zm11.376-7.5781l-10.376,5.8642v-10.3179l10.6997-6.8623-.3237,11.316Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "431.5819 42.4593 439.3788 30.5433 438.5418 29.9955 431.3905 40.9261 427.5716 37.4222 426.8958 38.1586 431.5819 42.4593"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M486.7667,328.3507c-.0497,1.4723,.8692,2.6982,2.0526,2.7382,1.1834,.04,2.1831-1.121,2.2329-2.5933,.0497-1.4722-.8692-2.6982-2.0526-2.7382s-2.1831,1.1211-2.2329,2.5933Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M488.0143,309.2189c-.0497,1.4722,.8692,2.6981,2.0526,2.7381s2.1831-1.121,2.2329-2.5933c.0497-1.4722-.8692-2.6981-2.0526-2.7381-1.1834-.0401-2.1831,1.121-2.2329,2.5933Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.6185,
    y: 215.032,
    width: 198.1934,
    height: 0.9998,
    transform: "translate(117.0049 555.0943) rotate(-86.6609)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "242.8999 165.9086 246.2695 161.5546 245.4785 160.9423 242.8403 164.3509 237.5723 158.5179 236.8301 159.1879 242.8999 165.9086"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "338.5572 288.4447 337.2082 316.1689 244.884 292.3427 245.1798 274.5147 338.5572 288.4447"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "338.5572 288.4447 339.6735 288.7207 338.4097 315.6864 337.2082 316.1689 338.5572 288.4447"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M245.001,283.1088l.081-.4942-19.2812-3.1836,3.6523-51.5605,10.5957-1.0918-.0507-.4981-10.8047,1.1133c-.1211,.0127-.2159,.1104-.2237,.2315l-3.6836,51.998c-.0097,.1289,.0811,.2432,.208,.2647l19.5069,3.2207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M211.7949,210.0287c.0127,0,.0254-.001,.0381-.0029l29.8071-4.6426-.0771-.4942-29.4976,4.5948,5.4493-79.21,18.0595-7.5195-.1924-.4619-18.2021,7.5791c-.0879,.0366-.1475,.1191-.1533,.2138l-5.4805,79.6758c-.0059,.0762,.0244,.1504,.0801,.2022,.0459,.0419,.1064,.0654,.1689,.0654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M243.6225,282.7608c0,.9518,.4229,1.7233,.9446,1.7233s.9445-.7715,.9445-1.7233-.4229-1.7233-.9445-1.7233-.9446,.7715-.9446,1.7233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M284.6261,302.5089c0,.9517,.4229,1.7233,.9446,1.7233s.9446-.7716,.9446-1.7233-.4229-1.7234-.9446-1.7234-.9446,.7716-.9446,1.7234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M414.0757,323.8733l-47.2156-13.5132c-6.4524-1.8467-13.1447,2.0482-14.7263,8.5706h0c-1.4061,5.7988,1.7343,11.7355,7.3191,13.8362l50.7782,19.1006c6.2562,2.3533,13.178-1.2007,14.9115-7.6561l.1414-.5265c2.2976-8.5561-2.691-17.3739-11.2083-19.8116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M412.6349,324.9164l-47.2156-13.5132c-6.4524-1.8467-13.1447,2.0482-14.7263,8.5706h0c-1.4061,5.7988,1.7343,11.7355,7.3191,13.8362l50.7782,19.1006c6.2561,2.3533,13.178-1.2006,14.9115-7.6561l.1414-.5264c2.2976-8.5562-2.691-17.374-11.2083-19.8117Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 382.2543,
    cy: 331.7664,
    rx: 16.7138,
    ry: 28.2783,
    transform: "translate(-38.3875 613.2763) rotate(-74.7474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M378.9659,341.9519c0,.9517,.4229,1.7233,.9446,1.7233s.9445-.7716,.9445-1.7233-.4229-1.7234-.9445-1.7234-.9446,.7716-.9446,1.7234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M239.1396,226.2873c0,.9518,.4229,1.7233,.9445,1.7233s.9446-.7715,.9446-1.7233-.4229-1.7233-.9446-1.7233-.9445,.7715-.9445,1.7233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M240.6198,204.4567c0,.9517,.4229,1.7233,.9446,1.7233s.9445-.7716,.9445-1.7233-.4229-1.7233-.9445-1.7233-.9446,.7715-.9446,1.7233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M234.886,122.0978c0,.9518,.4229,1.7234,.9445,1.7234s.9446-.7716,.9446-1.7234-.4229-1.7233-.9446-1.7233-.9445,.7716-.9445,1.7233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M379.9106,368.4095c.0484,0,.0962-.0136,.1377-.041,.0704-.0468,.1123-.125,.1123-.209v-25.7929h-.5v25.415l-93.9023-39.9599v-24.9756h-.5v25.1406c0,.1006,.0601,.1904,.1523,.2305l94.4024,40.1728c.0312,.0127,.0644,.0195,.0976,.0195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M405.8005,265.3408c-.0786,2.1054-1.0288,3.7791-2.1224,3.7383-1.0936-.0408-1.9165-1.7807-1.8379-3.8861,.0786-2.1054,1.0288-3.7792,2.1224-3.7383,1.0936,.0408,1.9165,1.7806,1.8379,3.8861Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M372.9673,268.5792c-.0785,2.1054-1.0288,3.7791-2.1224,3.7383s-1.9164-1.7806-1.8379-3.8861c.0786-2.1054,1.0288-3.7791,2.1224-3.7383s1.9165,1.7807,1.8379,3.8861Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 422.1707,
    y: 225.5457,
    width: 0.9422,
    height: 30.7911,
    transform: "translate(-63.7837 249.2483) rotate(-30.6652)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 374.8183,
    y: 229.7166,
    width: 25.4476,
    height: 0.9435,
    transform: "translate(-58.8346 292.8252) rotate(-38.6968)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 373.1428,
    y: 209.0412,
    width: 21.745,
    height: 0.9427,
    transform: "translate(-16.0383 32.5369) rotate(-4.7525)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 421.977,
    y: 203.4647,
    width: 22.0844,
    height: 0.9434,
    transform: "translate(-26.6861 70.6445) rotate(-9.0492)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 404.1007,
    y: 174.2966,
    width: 33.5422,
    height: 0.9428,
    transform: "translate(134.2226 529.0406) rotate(-73.5738)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 392.5488,
    y: 161.8176,
    width: 0.9438,
    height: 32.5808,
    transform: "translate(-37.7457 153.0469) rotate(-21.0494)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M365.1462,279.1322l-4.918-6.0479,.5879-11.0527,5.5322-5.4922,4.919,6.0479-.5889,11.0527-5.5322,5.4922Zm-4.2227-6.2744l4.2774,5.2607,4.8115-4.7773,.5596-10.5274-4.2784-5.2607-4.8115,4.7773-.5586,10.5274Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M365.5583,272.6146c-.0215,0-.044-.001-.0655-.0019-.6269-.0332-1.1757-.545-1.5439-1.4414-.3428-.835-.498-1.9229-.4365-3.0635,.0605-1.1406,.3301-2.2061,.7597-3,.461-.8516,1.0665-1.292,1.6885-1.2695,.627,.0332,1.1758,.5449,1.544,1.4414,.3427,.8349,.498,1.9228,.4365,3.0634h0c-.0606,1.1407-.3301,2.2061-.7598,3-.4453,.8223-1.0195,1.2715-1.623,1.2715Zm.3398-8.2695c-.4043,0-.831,.3642-1.1787,1.0049-.3935,.7285-.6426,1.7177-.6992,2.7851-.0566,1.0664,.085,2.0762,.3994,2.8428,.2852,.6943,.6865,1.1045,1.1006,1.127,.418,.0087,.8564-.3448,1.2139-1.004,.3935-.7285,.6425-1.7177,.6992-2.7851h0c.0566-1.0664-.085-2.0762-.3994-2.8428-.2852-.6943-.6866-1.1045-1.1006-1.1269-.0117,0-.0235-.001-.0352-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.1164,242.2939c-.9324,6.5764,4.4154,12.773,11.9447,13.8405,7.5293,1.0676,14.3889-3.3982,15.3214-9.9745,.9324-6.5763-4.4154-12.7729-11.9447-13.8405-7.5293-1.0676-14.389,3.3982-15.3214,9.9745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M422.6342,220.6254c-.9325,6.5763,1.3736,12.3417,5.1508,12.8772,3.7771,.5356,7.595-4.3615,8.5275-10.9378,.9324-6.5763-1.3737-12.3417-5.1509-12.8772-3.7771-.5356-7.595,4.3615-8.5274,10.9378Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "403.6052 274.0218 370.5378 268.8754 370.6999 267.8324 402.6286 272.8011 403.1452 265.2006 404.1979 265.2728 403.6052 274.0218"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "231.4681 177.7104 225.2899 289.4728 401.8248 330.52 411.0279 142.6032 231.4681 177.7104"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "411.0279 142.6032 409.477 142.6861 400.0693 330.3291 401.8248 330.52 411.0279 142.6032"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 415.3111,
    cy: 142.2859,
    rx: 66.2975,
    ry: 66.3534
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "340.5695 160.9536 337.9225 204.8274 401.5399 201.474 403.2568 148.3499 340.5695 160.9536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 314.0435,
    cy: 191.9967,
    rx: 93.4746,
    ry: 39.3863,
    transform: "translate(96.9095 489.2153) rotate(-85.2902)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 307.8853,
    cy: 191.4894,
    rx: 58.8877,
    ry: 20.9201,
    transform: "translate(91.763 482.6126) rotate(-85.2903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M312.5818,193.6944c-1.0341,12.5527-5.4876,22.4309-9.947,22.0636-4.4595-.3674-7.2362-10.8413-6.202-23.3941s5.4876-22.431,9.947-22.0636c4.4595,.3674,7.2362,10.8413,6.202,23.3941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M132.669,289.986s1.6168,17.6974,9.2753,17.6974c7.7144,0,18.4054-14.6136,18.4054-14.6136l-27.6807-3.0838Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 144.8362,
    cy: 295.3418,
    rx: 23.2639,
    ry: 32.5122,
    transform: "translate(-161.4002 415.44) rotate(-85.2904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M185.7241,278.5995l-.3055,.893c-3.7835,9.2903-33.0096,21.4268-42.5386,18.8631-9.3611-2.5186-15.4483-12.506-18.2713-22.3213-2.474-8.6019-1.7236-19.6266,1.4098-22.7599,3.1333-3.1333,12.643-10.6377,28.5681-9.6664,15.6902,.9557,20.633,7.3634,25.4818,12.2122,5.5774,5.5774,7.2067,17.3038,5.6557,22.7793Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M185.7241,278.5995l-.3055,.893s-23.9377,11.6751-43.0018,1.4536c-17.4634-9.3631-16.3983-27.6717-16.3983-27.6717,3.1333-3.1333,12.643-10.6377,28.5681-9.6664,15.6902,.9557,20.633,7.3634,25.4818,12.2122,5.5774,5.5774,7.2067,17.3038,5.6557,22.7793Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 152.9455,
    cy: 249.015,
    rx: 14.3937,
    ry: 3.6719
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M164.106,249.7593c0,1.6169-5.138,2.9276-11.4761,2.9276s-11.476-1.3107-11.476-2.9276,5.138-2.9275,11.476-2.9275,11.4761,1.3107,11.4761,2.9275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M116.298,222.6972l-8.57-3.36-1.5-.59c.01,0,.01-.01,.01-.01,.18-.28,3.51-5.12,7.25-4.04,3.85,1.11,2.81,8,2.81,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M181.8116,139.0652c-5.7428,0-14.5702-10.1362-14.5702-22.0593,0-8.312,6.1113-12.909,10.8645-12.909s9.5065,10.5116,9.5065,21.2708-3.589,13.6975-5.8008,13.6975Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M198.457,147.3448s-.1706,10.2431-1.6878,14.1932c-.2065,.5386-.4398,.9695-.7002,1.2298-2.1725,2.1636-15.1178,11.6706-35.9094,11.6706s-36.807-8.0796-38.4588-11.5269c-.4669-.9785-.8888-1.975-1.2569-2.9984-6.6881-18.1971,1.1132-42.3192,9.9379-48.7649,5.539-4.0488,31.7977-10.7908,47.4722,.8528,16.6081,12.3528,17.9098,34.3024,17.9098,34.3024l2.6932,1.0414Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M142.4168,233.736s1.6167,17.6974,9.2753,17.6974c7.7143,0,18.4054-14.6136,18.4054-14.6136l-27.6807-3.0838Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M194.428,205.1571c0,2.2801-.35,12.4101-9.66,21.7201-7.99,7.99-19.58,13.3399-29.63,13.3399-8.24,0-18.02-10.19-22.8199-21.0999l-.0201-.03c-.44-1-.84-2.01-1.19-3.02-4.17-11.98-4.5999-24.24-1.7-27.94,.82-1.05,1.7201-2.01,2.68-2.88,1.47-1.35,3.1-2.51,4.83-3.49,16.03-9.11,41.54-3.67,45.16-.42,.4,.36,.79,.75,1.1801,1.16,5.9499,6.31,10.3799,18.2999,11.0699,21.9099,.07,.32,.1,.57,.1,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M196.7692,161.538c-.2065,.5386-.4398,.9695-.7002,1.2298-2.1725,2.1636-15.1178,11.6706-35.9094,11.6706s-36.807-8.0796-38.4588-11.5269c-.4669-.9785-.8888-1.975-1.2569-2.9984,0,0,6.0059,3.941,13.9777,3.151,7.9719-.79,39.7427-9.6686,62.3476-1.5261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M178.4631,168.8246c0,2.1071-7.6032,3.8153-16.9822,3.8153s-16.9821-1.7082-16.9821-3.8153,7.6032-3.8154,16.9821-3.8154,16.9822,1.7082,16.9822,3.8154Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 160.6484,
    cy: 168.4157,
    rx: 13.8304,
    ry: 3.1073
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.818,168.4157s5.0533,12.3786,13.8304,12.3786c8.841,0,13.8304-12.3786,13.8304-12.3786-3.0588-4.0267-25.1531-4.2323-27.6608,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M194.427,205.162c-4.3397,4.3397-28.2,6.9874-38.3834,1.5041-10.1833-5.4834-19.1211-24.91-19.1211-24.91,16.027-9.1102,41.5401-3.666,45.1513-.4152,6.5408,5.875,11.5228,19.223,12.2592,23.0613l.094,.7598Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M123.1571,136.6762c6.327,0,16.0525-11.1673,16.0525-24.3034,0-9.1576-6.733-14.2223-11.9698-14.2223s-10.4736,11.5811-10.4736,23.4347,3.9541,15.091,6.3909,15.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M133.2995,116.9386c-.386,5.3325-2.2713,10.5842-4.6413,14.0405-1.7596,2.5855-3.7974,4.1744-5.6827,4.0308-4.3989-.3321-5.53-12.5592-5.0452-19.0768,.5566-7.4602,4.5245-17.0569,9.085-17.0569,2.5047,0,4.6234,3.4832,5.6737,8.4027,.6105,2.8728,.8619,6.2303,.6105,9.6597Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M133.2995,116.9386c-.386,5.3325-2.2713,10.5842-4.6413,14.0405-2.6573-2.3161-3.3396-8.6541-2.9446-12.3438,.4669-4.3541,3.3575-9.7584,6.9754-11.3564,.6105,2.8728,.8619,6.2303,.6105,9.6597Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M112.118,275.3072l-33.1-2.8401c.37-3.3499,.96-6.68,1.75-9.9499v-.02c4.91-20.51,17.14-38.61,25.46-43.75,.01,0,.01-.01,.01-.01,2.19-1.35,4.11-1.81,5.55-1.17,2.0301,.8999,3.5,2.7,4.51,5.13,6.16,14.73-4.18,52.61-4.18,52.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M79.0185,272.4661c-2.3148,5.4562,4.2104,9.0935,14.3937,10.128,10.1834,1.0344,17.7505-3.5418,18.7021-7.2908,.9516-3.749-6.3465-9.6914-16.5878-9.6914s-15.1372,3.6229-16.508,6.8542Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M132.3181,219.1172l-.0201-.03-4.13-7.0401s-6.59-14.51,.5901-25.8399v-.01s3.1399-2.9101,8.1599-4.44c0,0,.31,.6599,.73,1.8499,1.93,5.36,6.18,21.4101-5.3299,35.5101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M131.9796,210.1597h-.0078c-1.081,1.5275-2.3813,2.0445-3.2117,1.7312-1.8956-.7207-6.8541-17.954,0-25.6855,0,0,.4779,.3603,1.1515,1.3082,1.1672,1.645,2.914,5.0681,3.7444,11.4523,.7363,5.64-.2977,9.2433-1.6764,11.1938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M131.9796,210.1597h-.0078c-.8353-.8353-2.5536-2.799-3.2743-7.4756-1.175-7.6375,1.2141-15.1705,1.2141-15.1705,1.1672,1.645,2.914,5.0681,3.7444,11.4523,.7363,5.64-.2977,9.2433-1.6764,11.1938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M131.1365,189.6267s-15.7871,16.2809-14.7101,22.3517c1.0771,6.0708,16.4609-3.5023,16.4609-3.5023,0,0,2.0942-5.6325-1.7508-18.8494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.1365,189.6267s-9.3124,11.4993-8.2354,17.5701c1.0771,6.0709,9.9862,1.2793,9.9862,1.2793,0,0,2.0942-5.6325-1.7508-18.8494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M83.7185,271.7806s12.4354-5.2875,19.8771-1.4687l3.3291,6.7562-2.9375,11.318s-13.3166,5.5237-24.9687,1.2154l-.467-6.2667s1.7934-6.4196,5.167-11.5542Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M105.7824,296.2598s3.6882,2.4479,8.1923,.6854c0,0,1.1983-14.3005-7.9196-21.6419,0,0-3.047,1.7959-2.5575,7.4393,.4896,5.6435,2.2848,9.0457,2.2848,13.5172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M79.0185,285.1952s-1.7173,10.8688-.467,14.2958c1.2503,3.4271,11.364,4.8203,11.364,4.8203l-5.2178-19.8015s-2.5459-1.175-5.6792,.6854Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M84.0122,283.6285s-2.6437,8.7178,0,13.9548c2.6438,5.2369,7.0743,8.2723,7.0743,8.2723,0,0,5.1653-1.175,5.8507-4.1125,.6854-2.9375-5.0795-18.1146-5.0795-18.1146h-7.8455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M101.7351,281.4091c-.6662-1.7767-7.6375-2.0889-9.4652,1.175-1.8278,3.2639-1.1097,16.7764-.6528,17.2333,.4569,.457,5.7444,3.5903,9.2694,1.9584,3.525-1.632,4.0473-6.1361,3.4598-7.9639-.5875-1.8278-2.0237-10.8361-2.6112-12.4028Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M91.6171,299.8174c-.2651-1.4712,6.2437-7.2629,12.8482-5.4919,0,0,1.7087,6.0342-4.2315,7.9173-5.9403,1.883-8.6167-2.4254-8.6167-2.4254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M187.6124,122.5024s-16.2341-10.1296-39.3881,0c0,0-9.0147,5.9277-9.0147,17.4655,0,0,11.9719,1.7777,19.397-1.3848,0,0,6.516-9.4895,17.5597-9.4895s14.8126,10.8743,14.8126,10.8743l4.486,2.0746s-3.053-14.7405-7.8525-19.5401Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M195.7638,146.3034c-25.7381-10.2521-70.1489,6.9934-70.1489,6.9934-6.2303-3.591-4.9107-18.2779-4.9107-18.2779,0,10.4496,5.8623,16.1502,5.8623,16.1502,45.6677-18.7357,69.1973-4.8657,69.1973-4.8657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M195.7638,146.3034c-25.7381-10.2521-70.1489,6.9934-70.1489,6.9934l.9516-2.1277c45.6677-18.7357,69.1973-4.8657,69.1973-4.8657Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 156.6154,
    cy: 248.8957,
    rx: 18.4854,
    ry: 25.8341,
    transform: "translate(-104.2994 384.5456) rotate(-85.2902)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 163.462,
    cy: 171.1616,
    rx: 20.3067,
    ry: 28.3794,
    transform: "translate(-20.5429 320.0184) rotate(-85.2904)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 93.5477,
    cy: 239.9517,
    rx: 35.0179,
    ry: 25.0568,
    transform: "translate(-154.9797 172.4082) rotate(-53.4968)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 129.062,
    cy: 117.6583,
    rx: 26.5905,
    ry: 28.4731,
    transform: "translate(1.2037 236.6235) rotate(-85.2901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M113.488,214.6972l-1.7,2.87c-1.35,.31-2.71,.9099-4.06,1.77-13.9099,8.73-26.96,43.18-26.96,43.18v-.02c4.91-20.51,17.14-38.61,25.46-43.75,.01,0,.01-.01,.01-.01,.18-.28,3.51-5.12,7.25-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M183.2581,182.4972c-20.3601-9.5801-44.11-1.72-46.3401-.74-.12,.05,.56,1.1529,.56,1.1529l-3.7613,.7083-4.9586,2.5888v-.01s3.1399-2.9101,8.1599-4.44c16.03-9.11,41.54-3.67,45.16-.42,.4,.36,.79,.75,1.1801,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M138.5549,107.6641l.527,2.6016s23.5231-7.8358,38.7721,1.7353c0,0-11.7222-11.2449-39.2991-4.3369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M147.4711,127.9714l17.984-1.8418s-4.1553,7.1855-10.8081,7.1855-7.1759-5.3437-7.1759-5.3437Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M155.7536,121.7818c7.5738-.4579,13.9204,2.5916,14.1755,6.8111,.255,4.2196-5.6779,8.0113-13.2517,8.4692-7.5738,.4578-13.9204-2.5916-14.1755-6.8111-.255-4.2196,5.6779-8.0114,13.2517-8.4692Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M184.1384,126.5243s5.5802,1.0831,7.4195,2.6354c0,0,2.088,4.1881-.5092,4.0363-3.063-.179-6.9103-6.6717-6.9103-6.6717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M191.105,122.8029c6.2339,2.8352,10.007,7.9489,8.4275,11.422-1.5796,3.473-7.9136,3.9902-14.1475,1.155-6.2339-2.8351-10.007-7.9489-8.4275-11.4219,1.5796-3.4731,7.9136-3.9902,14.1475-1.1551Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M478.4949,72.7095c19.8454,.915,34.8053,26.1792,33.4107,56.4248-.157,3.4059-.5186,6.7358-1.0585,9.9575-1.4825,8.8639-4.3508,16.9065-8.2131,23.5796-7.1651,12.4063-17.7426,20.1017-29.1896,19.5739-19.8537-.9154-34.8136-26.1795-33.4191-56.4252,1.3946-30.2457,18.6159-54.026,38.4696-53.1106Zm-6.5651,98.6939c15.0688,.6948,28.1886-18.4463,29.3097-42.7609,1.1207-24.3061-10.1817-44.5817-25.2505-45.2765-15.0606-.6944-28.1807,18.4551-29.3014,42.7613-1.1211,24.3145,10.1816,44.5817,25.2422,45.2761Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M471.2728,171.3457c-.2241-.0015-.4471,.0068-.6721-.0036-15.0606-.6944-26.3633-20.9616-25.2422-45.2761,1.1207-24.3062,14.2408-43.4557,29.3014-42.7612,.225,.0103,.4463,.0392,.6696,.0583-14.7764-.1036-27.5257,18.8215-28.6297,42.7647-1.1044,23.9515,9.8497,43.9615,24.573,45.2179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M501.3049,162.6101c3.8623-6.6731,6.7306-14.7157,8.2131-23.5796,.5399-3.2217,.9015-6.5516,1.0585-9.9574,1.3788-29.903-13.2318-54.9203-32.7414-56.3681,.2243,.004,.447-.0053,.672,.0051,19.8454,.915,34.8053,26.1791,33.4108,56.4248-.1571,3.4059-.5187,6.7357-1.0586,9.9574-1.4825,8.864-4.3507,16.9065-8.2131,23.5797-7.1651,12.4063-17.7426,20.1017-29.1896,19.5739-.1648-.0076-.3264-.0307-.4906-.0416,11.1191,.1185,21.3518-7.4959,28.3389-19.5942Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M446.6907,126.1245c-1.1211,24.3145,10.1817,44.5817,25.2422,45.2761,15.0689,.6948,28.1887-18.4463,29.3098-42.7608,1.1207-24.3063-10.1817-44.5817-25.2505-45.2765-15.0606-.6945-28.1807,18.455-29.3015,42.7612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.3739,72.4279c18.7419,.8641,32.8047,26.0846,31.4101,56.3316-1.3947,30.2469-17.7186,54.0664-36.4605,53.2022-18.7419-.8641-32.8047-26.0847-31.4101-56.3316,1.3946-30.247,17.7186-54.0664,36.4605-53.2022Zm-4.6268,100.3451c15.5975,.7192,29.1826-19.1039,30.3432-44.276,1.1607-25.1722-10.5427-46.1613-26.1401-46.8804-15.5975-.7192-29.1825,19.1039-30.3432,44.276-1.1606,25.1722,10.5427,46.1613,26.1401,46.8804Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M466.9897,172.7126c-.2084-.0023-.4156,.0063-.6247-.0033-15.5974-.7192-27.3007-21.7082-26.1401-46.8804,1.1607-25.1722,14.7457-44.9952,30.3431-44.2761,.2092,.0097,.4147,.0373,.6224,.0542-15.3333-.1687-28.5734,19.4447-29.7185,44.2794-1.145,24.8347,10.2341,45.5833,25.5178,46.8262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M502.5817,128.743c1.3791-29.9094-12.3595-54.8878-30.7877-56.2774,.2085,.0035,.4156-.0063,.6247,.0033,18.742,.8642,32.8047,26.0847,31.4101,56.3316-1.3946,30.247-17.7185,54.0664-36.4605,53.2023-.2091-.0097-.4144-.0385-.6224-.0542,18.4779,.3121,34.4568-23.2961,35.8358-53.2056Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M450.6767,108.9477c-1.8036,7.2137-.25,13.8155,3.4699,14.7456,3.72,.9301,8.1977-4.1638,10.0013-11.3775,1.8036-7.2136,.2501-13.8155-3.4699-14.7456-3.7199-.93-8.1977,4.1638-10.0013,11.3775Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M449.7782,129.6614c-.111,2.4089,1.3115,4.4315,3.1773,4.5175,1.8658,.0861,3.4683-1.797,3.5794-4.206s-1.3114-4.4316-3.1772-4.5176c-1.8658-.086-3.4684,1.7971-3.5795,4.2061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M475.9879,127.7152c0,5.1337-1.7231,9.2953-3.8485,9.2953s-3.8486-4.1616-3.8486-9.2953,1.7231-9.2953,3.8486-9.2953,3.8485,4.1617,3.8485,9.2953Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 470.6859,
    cy: 127.7152,
    rx: 3.8485,
    ry: 9.2953
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M471.141,129.8171l.136,1.1257c-1.1288,0-2.0439-.9151-2.0439-2.0439l1.4257-41.2204,1.2879-.2501,1.3742,2.1274v39.3431c0,1.1288-1.0511,.9182-2.1799,.9182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.9891,131.1929h0c-1.1288,0-2.0438-.9151-2.0438-2.0439l.7672-37.1631,1.9463-4.3074,1.3742,2.1274v39.3431c0,1.1288-.9151,2.0439-2.0439,2.0439Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "470.9078 130.8211 491.5932 124.6099 496.2467 116.8301 491.8761 114.1774 471.0712 126.6643 470.9078 130.8211"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "469.9891 131.1929 490.6746 124.9817 495.328 117.2019 490.9574 114.5492 470.1525 127.036 469.9891 131.1929"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "376.6725 51.0946 322.6271 79.1163 322.7262 77.5885 376.7831 49.1703 376.6725 51.0946"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "380.009 56.3617 326.006 82.9185 326.1059 81.3632 380.1203 54.41 380.009 56.3617"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "406.4106 35.6759 377.9858 50.4137 378.0966 48.4798 406.5275 33.5334 406.4106 35.6759"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "409.3595 34.147 407.5415 35.0896 407.6587 32.9388 409.477 31.9829 409.3595 34.147"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "408.9254 42.1417 403.5914 44.7648 403.7078 42.6398 409.0429 39.9776 408.9254 42.1417"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "323.5397 84.1313 321.7232 85.0246 321.8221 83.5008 323.639 82.5942 323.5397 84.1313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "402.4207 45.3405 382.3035 55.2334 382.4153 53.2648 402.5368 43.2241 402.4207 45.3405"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "357.7605 73.7264 321.8952 90.4039 321.9942 88.8761 357.8672 71.9351 357.7605 73.7264"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "379.1862 70.7824 325.2682 94.4092 325.3681 92.854 379.2976 68.8306 379.1862 70.7824"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "358.5024 86.3319 320.627 101.9121 320.7259 100.3883 358.6094 84.5293 358.5024 86.3319"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "407.1835 66.3067 369.3081 81.8869 369.4175 80.0048 407.3009 64.1458 407.1835 66.3067"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "405.547 51.5055 377.1668 64.7024 377.2777 62.7685 405.6639 49.363 405.547 51.5055"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "408.4912 50.1364 406.6761 50.9805 406.7933 48.8297 408.6088 47.9723 408.4912 50.1364"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "408.0571 58.1312 402.7315 60.4648 402.8479 58.3399 408.1746 55.9671 408.0571 58.1312"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "322.8058 95.4883 320.9921 96.283 321.091 94.7592 322.9051 93.9512 322.8058 95.4883"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "401.5627 60.977 388.3887 66.7498 388.5021 64.7304 401.6788 58.8607 401.5627 60.977"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "374.6303 86.6383 320.7973 107.3353 320.8964 105.8075 374.7409 84.714 374.6303 86.6383"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "377.9521 92.4133 324.1615 111.6454 324.2614 110.0901 378.0634 90.4616 377.9521 92.4133"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "404.2516 75.2499 375.9384 86.1354 376.0492 84.2015 404.3685 73.1074 404.2516 75.2499"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "407.1888 74.1206 405.378 74.8168 405.4951 72.6661 407.3064 71.9565 407.1888 74.1206"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "406.7547 82.1154 401.4417 84.015 401.5581 81.89 406.8722 79.9513 406.7547 82.1154"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "321.7049 112.5237 319.8955 113.1706 319.9944 111.6469 321.8042 110.9866 321.7049 112.5237"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "400.2756 84.4319 380.2375 91.5962 380.3494 89.6276 400.3918 82.3155 400.2756 84.4319"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "373.8134 100.8557 320.0654 118.6228 320.1645 117.0951 373.924 98.9315 373.8134 100.8557"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "377.1293 106.834 323.4237 123.1361 323.5236 121.5809 377.2406 104.8822 377.1293 106.834"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "356.5254 119.6273 318.7993 130.0581 318.8983 128.5343 356.6324 117.8247 356.5254 119.6273"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "405.0146 106.2206 367.2885 116.6514 367.3979 114.7693 405.132 104.0597 405.0146 106.2206"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "403.3879 91.0795 375.1195 100.424 375.2303 98.4901 403.5048 88.937 403.3879 91.0795"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "406.3206 90.1101 404.5126 90.7078 404.6297 88.557 406.4381 87.946 406.3206 90.1101"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "405.8864 98.1048 400.5818 99.715 400.6982 97.5901 406.004 95.9407 405.8864 98.1048"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "320.971 123.8807 319.1644 124.429 319.2634 122.9053 321.0703 122.3436 320.971 123.8807"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "399.4176 100.0684 379.4112 106.1413 379.523 104.1727 399.5337 97.9521 399.4176 100.0684"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "276.7014 99.3191 240.2412 118.2231 240.308 117.1925 276.776 98.021 276.7014 99.3191"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "278.9522 102.8724 242.5207 120.7882 242.588 119.739 279.0274 101.5557 278.9522 102.8724"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "296.7634 88.9173 277.5873 98.8598 277.6621 97.5551 296.8422 87.4719 296.7634 88.9173"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "298.7528 87.8859 297.5263 88.5217 297.6053 87.0708 298.832 86.4259 298.7528 87.8859"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "298.4599 93.2793 294.8614 95.0489 294.94 93.6153 298.5392 91.8193 298.4599 93.2793"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "240.8568 121.6064 239.6313 122.209 239.6981 121.1811 240.9238 120.5694 240.8568 121.6064"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "294.0717 95.4372 280.5002 102.1112 280.5756 100.7831 294.15 94.0095 294.0717 95.4372"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "263.9429 114.587 239.7474 125.838 239.8142 124.8074 264.0149 113.3786 263.9429 114.587"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "278.3972 112.6009 242.0229 128.5401 242.0903 127.4909 278.4723 111.2842 278.3972 112.6009"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "264.4434 123.0909 238.8919 133.6017 238.9586 132.5737 264.5156 121.8749 264.4434 123.0909"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "297.2848 109.5815 271.7332 120.0922 271.807 118.8225 297.364 108.1237 297.2848 109.5815"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "296.1808 99.5963 277.0349 108.4992 277.1096 107.1946 296.2596 98.1509 296.1808 99.5963"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "298.167 98.6727 296.9425 99.2421 297.0215 97.7911 298.2463 97.2127 298.167 98.6727"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "297.8741 104.0661 294.2814 105.6405 294.3599 104.2069 297.9534 102.6062 297.8741 104.0661"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "240.3617 129.2681 239.1382 129.8042 239.2049 128.7762 240.4287 128.2311 240.3617 129.2681"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "293.4928 105.986 284.6054 109.8805 284.6819 108.5181 293.5712 104.5583 293.4928 105.986"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "275.3237 123.2977 239.0068 137.2603 239.0736 136.2296 275.3983 121.9995 275.3237 123.2977"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "277.5646 127.1936 241.2763 140.168 241.3437 139.1188 277.6397 125.8769 277.5646 127.1936"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "295.3068 115.6148 276.2061 122.9584 276.2809 121.6537 295.3857 114.1694 295.3068 115.6148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "297.2884 114.853 296.0668 115.3226 296.1458 113.8717 297.3677 113.393 297.2884 114.853"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "296.9955 120.2464 293.4112 121.5279 293.4897 120.0944 297.0748 118.7864 296.9955 120.2464"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "239.619 140.7605 238.3984 141.197 238.4651 140.169 239.686 139.7236 239.619 140.7605"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "292.6246 121.8092 279.1064 126.6424 279.1819 125.3143 292.7029 120.3814 292.6246 121.8092"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "274.7726 132.8891 238.513 144.8751 238.5798 143.8445 274.8472 131.5909 274.7726 132.8891"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "277.0095 136.9221 240.7786 147.9199 240.846 146.8707 277.0847 135.6054 277.0095 136.9221"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "263.1097 145.5528 237.6589 152.5896 237.7256 151.5617 263.1819 144.3367 263.1097 145.5528"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "295.8216 136.5083 270.3708 143.5452 270.4445 142.2755 295.9008 135.0505 295.8216 136.5083"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "294.7242 126.2938 275.6537 132.5978 275.7284 131.2932 294.8031 124.8484 294.7242 126.2938"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "296.7026 125.6398 295.4829 126.043 295.5619 124.592 296.7819 124.1799 296.7026 125.6398"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "296.4097 131.0332 292.8311 132.1195 292.9096 130.686 296.489 129.5733 296.4097 131.0332"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "239.1239 148.4222 237.9052 148.7921 237.9719 147.7642 239.1909 147.3852 239.1239 148.4222"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "292.0457 132.3579 278.5489 136.4548 278.6244 135.1268 292.1241 130.9302 292.0457 132.3579"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M450.2878,324.1752c-3.3379,0-5.9532-5.5518-5.9532-12.6377s2.6153-12.6387,5.9532-12.6387,5.9541,5.5518,5.9541,12.6387-2.6153,12.6377-5.9541,12.6377Zm0-24.2198c-2.6543,0-4.8965,5.3038-4.8965,11.5821s2.2422,11.581,4.8965,11.581,4.8974-5.3037,4.8974-11.581-2.2422-11.5821-4.8974-11.5821Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M449.6891,314.6488l-.1357-8.7744c-.0039-.2627,.2051-.4785,.4668-.4824h.0078c.2588,0,.4707,.208,.4746,.4668l.0908,5.8642,1.419-2.0078c.1523-.2139,.4472-.2627,.6621-.1133,.2139,.1514,.2646,.4473,.1133,.6621l-3.0987,4.3848Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "315.3805 219.9486 315.3053 219.8246 299.9186 194.3856 300.3464 194.1268 315.6579 219.4427 406.1247 217.4349 406.1364 217.9349 315.3805 219.9486"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "406.4323 232.5697 229.447 228.1205 229.4587 227.6205 406.444 232.0697 406.4323 232.5697"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "321.1511 230.1537 320.653 230.1205 321.3835 219.3363 321.8815 219.3695 321.1511 230.1537"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "402.2292 293.8265 226.0046 269.1009 226.0749 268.6049 402.2995 293.3304 402.2292 293.8265"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M302.1178,202.5912l-5.3623-7.5869c-.3193-.4512-.2119-1.0752,.2393-1.3936,.4502-.3188,1.0762-.2124,1.3936,.2393l3.5166,4.9746,8.3037-15.1177c.2666-.4844,.8769-.6606,1.3584-.395,.4843,.2661,.6611,.874,.3955,1.3579l-9.8448,17.9214Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "444.7194 312.016 434.4655 308.9427 434.4675 308.5687 434.8688 246.5951 435.8688 246.6009 435.4694 308.2006 445.0065 311.059 444.7194 312.016"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 444.8634,
    cy: 311.9671,
    rx: 1.6654,
    ry: 3.5784
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M285.518,245.1995c0,1.9763-.7457,3.5784-1.6654,3.5784s-1.6654-1.6021-1.6654-3.5784,.7456-3.5785,1.6654-3.5785,1.6654,1.6021,1.6654,3.5785Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "308.3483 175.0394 307.9186 174.7826 313.6667 165.162 313.78 165.1425 409.4645 148.8495 409.5485 149.3426 313.9772 165.6161 308.3483 175.0394"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 256.0229,
    y: 215.027,
    width: 0.4993,
    height: 56.1498,
    transform: "translate(-4.4846 481.3872) rotate(-85.9109)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "316.1198 258.0931 289.1794 256.2064 289.2145 255.7084 315.6569 257.5599 317.1432 236.4603 317.6413 236.4955 316.1198 258.0931"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M295.2341,257.3802c-.0225,0-.045-.0009-.0684-.0019-.5508-.0371-.9678-.5147-.9307-1.0654l.5118-7.6016c.038-.5508,.5039-.9512,1.0654-.9307,.5508,.0371,.9678,.5147,.9306,1.0655l-.5117,7.6015c-.0361,.5283-.4756,.9326-.997,.9326Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M302.4235,257.8842c-.0146,0-.0293,0-.0439-.001-.5518-.0235-.9795-.4903-.9561-1.042l.5586-13.0391c.0244-.5517,.4981-.9814,1.042-.956,.5518,.0234,.9795,.4902,.9561,1.042l-.5586,13.039c-.0235,.5371-.4659,.9571-.9981,.9571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M309.1452,258.3549c-.0264,0-.0537-.001-.0811-.003-.5507-.0449-.9609-.5263-.917-1.0771l1.3135-16.3389c.044-.5498,.5137-.9502,1.0772-.917,.5508,.0449,.9609,.5264,.917,1.0772l-1.3135,16.3388c-.042,.5235-.4805,.92-.9961,.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 289.9736,
    y: 242.523,
    width: 22.3968,
    height: 0.4996,
    transform: "translate(-83.1893 199.0742) rotate(-32.3859)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "310.1012 238.8793 309.6677 238.6312 310.6999 236.8265 308.3571 237.1175 308.2946 236.6215 311.6315 236.2074 310.1012 238.8793"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M319.07,200.4159c-.1484,0-.2988-.0371-.4375-.1152-.4287-.2427-.5801-.7867-.3379-1.2154l2.5274-4.4692-2.2237-4.7188c-.2099-.4453-.0185-.9765,.4268-1.1865,.4472-.209,.9765-.0185,1.1865,.4268l2.6162,5.5527-2.9805,5.273c-.164,.29-.4658,.4526-.7773,.4526Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M323.4059,200.0677c-.1484,0-.2988-.0371-.4375-.1152-.4287-.2427-.58-.7866-.3379-1.2153l2.5274-4.4688-2.2236-4.7192c-.21-.4453-.0186-.9766,.4267-1.1865,.4483-.209,.9766-.0186,1.1865,.4267l2.6162,5.5532-2.9804,5.2725c-.1641,.29-.4658,.4526-.7774,.4526Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M327.737,200.4159c-.1484,0-.2988-.0371-.4375-.1152-.4287-.2427-.5801-.7867-.3379-1.2154l2.5273-4.4692-2.2236-4.7188c-.21-.4453-.0185-.9765,.4268-1.1865,.4482-.209,.9765-.0185,1.1865,.4268l2.6162,5.5527-2.9805,5.273c-.164,.29-.4658,.4526-.7773,.4526Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M402.7819,344.1634c-.2305,0-.4609-.0888-.6357-.2666-.3457-.3515-.3409-.916,.0107-1.2607l3.5859-3.5254-2.7392-7.7754c-.1641-.4638,.0801-.9736,.5449-1.1367,.461-.1631,.9727,.0791,1.1367,.5449l3.1162,8.8438-4.3945,4.3203c-.1738,.1709-.3994,.2558-.625,.2558Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M407.0456,345.0248c-.2305,0-.461-.0889-.6358-.2666-.3457-.3516-.3408-.916,.0108-1.2608l3.5859-3.5244-2.7392-7.7763c-.1641-.4639,.08-.9737,.5449-1.1368,.4609-.1621,.9726,.0791,1.1367,.545l3.1162,8.8447-4.3945,4.3193c-.1738,.1709-.3994,.2559-.625,.2559Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M411.113,346.5531c-.2305,0-.461-.0889-.6358-.2666-.3457-.3516-.3408-.916,.0108-1.2607l3.5859-3.5245-2.7393-7.7754c-.164-.4638,.0801-.9736,.545-1.1367,.459-.1621,.9726,.0791,1.1367,.545l3.1162,8.8437-4.3945,4.3193c-.1739,.1709-.3994,.2559-.625,.2559Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "326.4311 70.7895 327.4142 60.4708 370.5054 33.8941 369.9698 45.3499 326.4311 70.7895"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "290.451 83.5197 291.8873 69.4961 304.8801 60.3432 303.9368 75.9755 290.451 83.5197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "304.8801 60.3432 305.5018 61.0404 304.8511 76.5892 303.9368 75.9755 304.8801 60.3432"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M296.7624,76.8509c-.0147,0-.0293-.0004-.044-.0014-.291-.0239-.5068-.2793-.4834-.5698l.6934-8.4156c.0234-.291,.2793-.5039,.5693-.4829,.291,.0239,.5069,.2793,.4834,.5698l-.6933,8.4156c-.0225,.2759-.2539,.4843-.5254,.4843Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M294.1501,74.6366c-.168,0-.333-.0796-.4356-.229-.165-.2402-.1035-.5689,.1367-.7339l5.8526-4.022c.2373-.1655,.5683-.105,.7344,.1363,.165,.2402,.1035,.5688-.1368,.7338l-5.8525,4.022c-.0908,.063-.1953,.0928-.2988,.0928Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotInterface);
export default __webpack_public_path__ + "static/media/robot-interface.08d96668bedecf1b41a49da82bac035e.svg";
export { ForwardRef as ReactComponent };